import { useState, useEffect, useMemo } from 'react';
import { callServerToGetUrls, processItems, converItemsToProGalleryItems } from '../../utils/itemsProcessor';
import ItemsDimensionsHelper from '../../utils/itemsDimensionsHelper';
export const useItems = (items, itemsSrc) => {
  const _useState = useState(processItems(converItemsToProGalleryItems(items, itemsSrc)).items),
    itemsToRender = _useState[0],
    setItemsToRender = _useState[1];
  let itemsDimensionsHelperRef = useMemo(() => new ItemsDimensionsHelper(), []);
  useEffect(() => {
    const result = processItems(converItemsToProGalleryItems(items || [], itemsSrc));
    const shouldFetchVideoUtlsFromVideoSDK = result.shouldGetVideoUrls;
    setItemsToRender(result.items);
    if (shouldFetchVideoUtlsFromVideoSDK) {
      callServerToGetUrls({
        newItems: converItemsToProGalleryItems(items, itemsSrc)
      }, setItemsToRender);
    }
    itemsDimensionsHelperRef == null ? void 0 : itemsDimensionsHelperRef.loadItemsDimensionsIfNeeded(itemsToRender, setItemsToRender);
  }, [items, itemsSrc]);
  return {
    itemsToRender
  };
};
//# sourceMappingURL=itemsHelper.js.map